import React from 'react';
import { Box, Image, Modal, ModalBody, ModalCloseButton, ModalOverlay, SimpleGrid, Text } from '@chakra-ui/react';
import { CompressorTypeModalContent } from './CompressorTypeModal_Styles';

export type CompressorTypeKey = 'compacto' | 'semi-hermetico' | 'scroll' | 'hermetico';

type CompressorTypeItem = {
  key: CompressorTypeKey;
  title: string;
  disabled?: boolean;
  image: string;
};

type Props = {
  isOpen: boolean;
  onBack: () => void;
  onSelect: (key: CompressorTypeKey) => void;
};

const compressorTypes: CompressorTypeItem[] = [
  {
    key: 'semi-hermetico',
    title: 'Semi-Hermético',
    image: '/assets/images/menu/compressores/semi-hermetico.jpg',
  },
  { key: 'hermetico', title: 'Hermético', image: '/assets/images/menu/compressores/hermetico.jpg' },
  { key: 'compacto', title: 'Compacto', image: '/assets/images/menu/compressores/compacto.jpg', disabled: true },
  { key: 'scroll', title: 'Scroll', image: '/assets/images/menu/compressores/scroll.jpg', disabled: true },
];

const CompressorTypeModal: React.FC<Props> = ({ isOpen, onBack, onSelect }) => (
  <Modal isOpen={isOpen} onClose={onBack} size="lg" isCentered>
    <ModalOverlay />
    <CompressorTypeModalContent borderRadius="10px" overflow="hidden">
      <ModalCloseButton
        onClick={onBack}
        top="8px"
        right="8px"
        color="#111111"
        fontSize="12px"
        width="28px"
        height="28px"
        display="flex"
        zIndex={2}
        aria-label="Voltar"
      />
      <ModalBody className="body">
        <Text className="title">
          Selecione o tipo de <b>Compressor</b>
        </Text>

        <SimpleGrid columns={[1, 2]} spacing={5} className="grid">
          {compressorTypes.map((item) => (
            <Box
              key={item.key}
              className={`card ${item.disabled ? 'card--disabled' : ''}`}
              onClick={() => !item.disabled && onSelect(item.key)}
              role="button"
              aria-disabled={item.disabled}
              tabIndex={item.disabled ? -1 : 0}
              onKeyDown={(event) => {
                if (!item.disabled && (event.key === 'Enter' || event.key === ' ')) onSelect(item.key);
              }}
                >
                  <Text className="cardTitle">{item.title}</Text>
                  <Box className="imageWrapper">
                    <Image className="compressorImage" src={item.image} alt={item.title} />
                  </Box>
                </Box>
          ))}
        </SimpleGrid>
      </ModalBody>
    </CompressorTypeModalContent>
  </Modal>
);

export default CompressorTypeModal;
